import { useContext, useEffect, useState } from "react";
import { ContainerModalSubirOrden } from "./localStyle";
import {
  wsPostOrdenConFirmaDigital,
  wsPostOrdenConFirmaDigitalLabo,
  wsPostSubirOrden,
} from "_+_Portal/context/Actions/ordenEstudio/ordenEstudio";
import { wsPostSubirOrdenLaboratorio } from "_+_Portal/context/Actions/ordenLaboratorio/ordenLaboratorio";
import { PortalContext } from "_+_Portal/context/Provider";
import { showToaster } from "global/context/action/toaster/toaster";
import { GlobalContext } from "global/context/Provider";
import { wsGetTurnosPacienteQr } from "_+_Portal/context/Actions/turnos/turnosPaciente";
import Loading from "../Loading/Loading";
import FrenteOrden from "../FrenteOrden/FrenteOrden";
import AutorizacionOrden from "../AutorizacionOrden/AutorizacionOrden";
import FirmaOrden from "../FirmaOrden/FirmaOrden";
import { getPlatforms } from "@ionic/react";

const ModalSubirOrden = ({
  turno,
  dissmiss,
  flgAutocheck,
  callback,
  nextStepATM,
  isMobile,
}) => {
  //#region ------------ context ---------------
  const {
    ordenLaboratorioDispatch,
    ordenEstudioDispatch,
    turnosPacienteDispatch,
  } = useContext(PortalContext);

  const { toasterDispatch } = useContext(GlobalContext);
  //#endregion --------- context ---------------

  //#region ------------ useStates ---------------
  const [altaOrdenConFirmaDto, setAltaOrdenConFirmaDto] = useState({
    firmaDigitalDto: { id: null, descripcion: null },
    listMediaDto: [
      {
        binario: null,
        idremoto: null,
        tag: "png",
      },
    ],
  });

  //#endregion --------- useStates ---------------

  //#region ------------ constants ---------------
  // const isMobile =
  //   Capacitor.platform === "android" || Capacitor.platform === "ios";
  const requiereAutorizacion = turno.requiereAutorizacion;
  const sinFirmaPacOrdenTurno = turno.sinFirmaPacOrdenTurno;
  const sinFirmaPacOrdenLabo = turno.sinFirmaPacOrdenLabo;
  const flgOrdenDigital = sessionStorage.getItem("flgOrdenDigital");
  //#endregion --------- constants ---------------

  //#region ------------ useStates ---------------
  const [paso, setPaso] = useState("frenteOrden");
  const [loading, setLoading] = useState(false);
  const [imagesCamera, setImagesCamera] = useState([]);
  //#endregion --------- useStates ---------------

  //#region  ----------- funtions --------------
  const nextStepSubirOrden = (isCorrect) => {
    setAltaOrdenConFirmaDto({
      firmaDigitalDto: { id: null, descripcion: null },
      listMediaDto: [
        {
          binario: null,
          idremoto: null,
          tag: "png",
        },
      ],
    });
    if (isCorrect) {
      if (flgAutocheck && callback) {
        callback();
      }
      setLoading(false);
      dissmiss();
      showToaster(
        {
          texto: "Orden guaradada exitosamente",
          tipo: "success",
        },
        "centroArriba",
      )(toasterDispatch);
      sessionStorage.removeItem("flgOrdenDigital");
    } else {
      dissmiss();
      showToaster(
        {
          texto: "Hubo un error al subir",
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);

      if (nextStepATM) {
        nextStepATM();
      }
    }
    wsGetTurnosPacienteQr()(turnosPacienteDispatch);
  };
  const finalizarProceso = (listaImagenes, autorizacion, firma) => {
    const firmaPaciente = !turno.idProtocolo
      ? sinFirmaPacOrdenTurno
      : sinFirmaPacOrdenLabo;

    if (requiereAutorizacion && !autorizacion) {
      setPaso("autorizacionOrden");
      setImagesCamera(listaImagenes);
    } else if (!firmaPaciente && !firma) {
      setPaso("firmaOrden");
      setImagesCamera([...imagesCamera, ...listaImagenes]);
    } else if (autorizacion) {
      const listaCompleta = [...imagesCamera, ...listaImagenes];
      const autorizacion = listaCompleta.pop();
      const objFinal = { ...altaOrdenConFirmaDto };
      objFinal.firmaDigitalDto = {
        id: turno?.idProtocolo ? turno?.idProtocolo : turno.idturno,
        descripcion: autorizacion.binario,
      };
      objFinal.listMediaDto = listaCompleta;
      if (turno?.idProtocolo) {
        wsPostOrdenConFirmaDigitalLabo(
          objFinal,
          flgOrdenDigital ? true : false,
          nextStepSubirOrden,
        )(ordenEstudioDispatch);
      } else {
        wsPostOrdenConFirmaDigital(
          objFinal,
          flgOrdenDigital ? true : false,
          nextStepSubirOrden,
        )(ordenEstudioDispatch);
        setLoading(true);
      }
    } else {
      setLoading(true);
      if (!turno?.idProtocolo) {
        wsPostSubirOrden(
          listaImagenes,
          nextStepSubirOrden,
        )(ordenEstudioDispatch);
      } else {
        wsPostSubirOrdenLaboratorio(
          listaImagenes,
          nextStepSubirOrden,
        )(ordenLaboratorioDispatch);
      }
    }
  };
  //#endregion --------- funtions ---------------

  useEffect(() => {
    if (flgOrdenDigital === "true") {
      setPaso("firmaOrden");
    }
  }, []);

  return (
    <ContainerModalSubirOrden flgAutocheck={flgAutocheck}>
      <Loading
        dataLoading={loading}
        color="c-white"
        descripcion={"Cargando..."}
      />
      {paso === "frenteOrden" ? (
        <FrenteOrden
          finalizarProceso={finalizarProceso}
          idTurno={turno?.idProtocolo ? turno.idProtocolo : turno.idturno}
          flgAutocheck={flgAutocheck}
          dissmiss={dissmiss}
        />
      ) : paso === "autorizacionOrden" ? (
        <AutorizacionOrden
          finalizarProceso={finalizarProceso}
          idTurno={turno?.idProtocolo ? turno.idProtocolo : turno.idturno}
          flgAutocheck={flgAutocheck}
          dissmiss={dissmiss}
        />
      ) : paso === "firmaOrden" ? (
        <FirmaOrden
          finalizarProceso={finalizarProceso}
          idTurno={turno?.idProtocolo ? turno.idProtocolo : turno.idturno}
          flgAutocheck={flgAutocheck}
          dissmiss={dissmiss}
          isMobile={
            getPlatforms()[0] === "android" ||
            getPlatforms()[0] === "ios" ||
            getPlatforms()[0] === "iphone"
              ? true
              : false
          }
        />
      ) : (
        ""
      )}
    </ContainerModalSubirOrden>
  );
};

export default ModalSubirOrden;
